//计算网段
function commonDhcp(val: any, rang: number) {
    console.log('计算网段 -> getDhcp', val, rang);
    // let rang:number = rang;
    let stringArray = val.split('.');
    let numerArray: any[] = [];
    let eachItmeArray = '';
    stringArray.forEach(function (item: any) {
        let eachString = parseInt(item).toString(2);
        //不满8位补0
        while (eachString.length < 8) {
            eachString = '0' + eachString;
        }
        numerArray.push(eachString);
        eachItmeArray += eachString;
    });
    //判断ip是否复合规范
    let sendBolean = false;
    eachItmeArray.split('').forEach(function (item, index) {
        if (index > rang) {
            if (item === '1') {
                sendBolean = true;
                return;
            }
        }
    });
    if (sendBolean) {
        // let sendAction = {};
        // sendAction.return = false;
        return;
    }

    if (rang <= 24) {
        // rang = 24;
    }
    let digitOfArray = Math.floor(rang / 8);
    let digitOfEach = rang % 8;
    // 计算最小IP
    let minNumArray = numerArray;
    //如果不是整数位数(8的倍数)
    if (digitOfEach) {
        let newNext = '';
        for (let i = digitOfEach; i < 8; i++) {
            newNext = '0' + newNext;
        }
        let newDigit = minNumArray[digitOfArray].split('');
        newDigit.splice(digitOfEach, 8 - digitOfEach, newNext);
        minNumArray[digitOfArray] = newDigit.join().replace(/\,/g, '');
    }
    //digitOfArray === 3 ? minNumArray[digitOfArray] = '00000000' : minNumArray[digitOfArray + 1] = '00000000';
    for (let i = digitOfArray; i < 4; i++) {
        minNumArray[i + 1] = '00000000';
        if (i === digitOfArray - 1) {
            let innerArray = minNumArray[i].split('');
            for (let j = digitOfEach; j < 9; j++) {
                innerArray[j - 1] = '0';
            }
            minNumArray[i] = innerArray.join();
        }
    }
    minNumArray.length = 4;
    //把2进制的数组转换成10进制的数组
    let paseIntMinArray: any[] = [];
    minNumArray.forEach(function (item) {
        paseIntMinArray.push(parseInt(item, 2));
    });

    /////////////计算最大IP
    let maxNumArray = numerArray;
    //如果不是整数位数(8的倍数)
    // console.log('digitOfEach', !!digitOfEach)
    if (digitOfEach) {
        if (digitOfArray > 2) {

            let newNext = '';
            for (let i = digitOfEach; i < 8; i++) {
                newNext = '1' + newNext;
            }

            let newDigit = maxNumArray[digitOfArray].split('');
            newDigit.splice(digitOfEach, 8 - digitOfEach, newNext);
            maxNumArray[digitOfArray] = newDigit.join().replace(/\,/g, '');
        } else if (digitOfArray <= 2) {
            let newTNext = '';
            for (let i = digitOfEach; i < 8; i++) {
                newTNext = '1' + newTNext;
            }

            let newDigit = maxNumArray[2].split('');
            // console.log('newDigit, newTNext, digitOfEach', newDigit, newTNext, digitOfEach);
            newDigit.splice(digitOfEach, 8 - digitOfEach, newTNext);
            // console.log('newDigit', newDigit);
            maxNumArray[2] = newDigit.join().replace(/\,/g, '');
            maxNumArray[3] = '11111111';
        }
    } else {
        if (digitOfArray == 2) {
            maxNumArray[2] = '11111111';
            maxNumArray[3] = '11111111';
            // console.log('maxNumArray', maxNumArray)
        }
    }

    //digitOfArray === 3 ? maxNumArray[digitOfArray] = '11111111' : maxNumArray[digitOfArray + 1] = '11111111';
    if (digitOfArray > 2) {
        // console.log('digitOfArray, digitOfEach', digitOfArray, digitOfEach)
        let innerArray = maxNumArray[3].split('');
        for (let j = digitOfEach; j < 8; j++) {
            innerArray[j] = '1';
        }
        maxNumArray[3] = innerArray.join('');
        maxNumArray.length = 4;
    }

    //把2进制的数组转换成10进制的数组
    let paseIntMaxArray: any[] = [];
    maxNumArray.forEach(function (item) {
        paseIntMaxArray.push(parseInt(item, 2));
    });
    let sendOut = {
        min: paseIntMinArray.join('.'),
        max: paseIntMaxArray.join('.'),
        holdIp: '',
        ip: '',
        dhcpMin: '',
        dhcpMax: ''
    };
    let myIp = paseIntMinArray;
    myIp[3] = myIp[3] + 1;
    sendOut.ip = myIp.join('.');
    let myHoldIp = paseIntMaxArray;
    myHoldIp[3] = myHoldIp[3] - 1;
    sendOut.holdIp = myHoldIp.join('.');
    let myMin = paseIntMinArray;
    myMin[3] = myMin[3] + 1;
    sendOut.dhcpMin = myMin.join('.');
    let myMax = paseIntMaxArray;
    myMax[3] = myMax[3] - 1;
    sendOut.dhcpMax = myMax.join('.');
    return sendOut;
}

export default {
    commonDhcp
};
